import classNames from 'classnames';

export const FormLabel = ({
  children,
  required,
  className,
}: {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}) => {
  return (
    <label
      className={classNames('flex-shrink-0 basis-1/4 text-right', className, {
        'required-field': required,
      })}
    >
      {children}
    </label>
  );
};
